import { z } from "zod";
import { ISODateSchema } from "./primitives.js";
// Signed-cookie issuance window: 4 hours. Frontend proactively refreshes
// 30 min before expiry; reactively refreshes on a photo <img> onerror.
export const CDN_COOKIE_TTL_SECONDS = 4 * 3600;
export const CDN_COOKIE_REFRESH_LEAD_SECONDS = 30 * 60;
// Body of POST /me/cdn-cookies. The Set-Cookie headers are separate
// (CloudFront-Policy, CloudFront-Signature, CloudFront-Key-Pair-Id).
// The body tells the client when the cookies expire so it can schedule
// a refresh — browsers can't read HttpOnly cookies.
export const CdnCookiesResponseSchema = z
    .object({
    expiresAt: ISODateSchema,
    // The CDN host the cookies are scoped to. Frontend uses this to
    // construct image URLs (and to clear cookies on logout).
    photosHost: z.string().min(1),
})
    .strict();
//# sourceMappingURL=cdn-cookies.js.map